import React from 'react';
import { MorevertIcons } from '../../../../icons/icons';
import { ContextMenuButton, NameEmailAvatar } from '../../../../ui';
import { OrganizationUser } from '../../../../utils/types/admin_types';

// Tooltip component for displaying truncated text with a hover tooltip
const TooltipWrapper: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className='relative group w-full flex items-center justify-start text-left'>
      { /* Truncated Text */ }
      <div className='max-w-[180px] truncate whitespace-nowrap overflow-hidden'>
        { text || '-' }
      </div>
      { /* Tooltip */ }
      <div className='absolute z-[9999] hidden group-hover:flex flex-col items-center'>
        <div className='relative'>
          { /* Tooltip Box */ }
          <div className='absolute bottom-full  px-3 py-2 text-sm text-white bg-gray-900 rounded-md shadow-lg w-max max-w-xs whitespace-normal'>
            { text }
          </div>
        </div>
      </div>
    </div>
  );
};

const columns = [
  { title: 'Name' },
  { title: 'Groups' },
  { title: 'Last Active' },
  { title: 'Actions' }, // Add Actions column for context menu or other actions
];
interface GetColumnsArgs {
  handleOpenMenu: (
    e: React.MouseEvent<HTMLButtonElement>,
    row: OrganizationUser
  ) => void;
  handleCloseMenu: () => void;
  anchorEl: HTMLElement | null;
}
export const getColumns = ({
  handleOpenMenu,
  handleCloseMenu,
  anchorEl,
}: GetColumnsArgs) => {
  return columns.map((col) => {
    if (col.title === 'Name') {
      return {
        key: 'Name',
        label: 'User',
        width: '250px',
        align: 'left' as const,
        render: (row: any) => (
          <NameEmailAvatar
              email={row['user']?.email}
              name={`${row['user']?.firstName} ${row['user']?.lastName}`}
              avatar={row['user']?.avatar}
          />
        ),
        disableSort: true,
      };
    }

    if (col.title === 'Groups') {
      return {
        key: 'Groups',
        label: 'Groups',
        width: '250px',
        align: 'left' as const,
        render: (row: any) => (
          <TooltipWrapper
              text={row['groups']
                ?.map((group: any) => group.groupName)
                .join(', ')}
          />
        ),
        disableSort: true,
      };
    }

    if (col.title === 'Last Active') {
      return {
        key: 'Last Active',
        label: 'Last Active',
        width: '250px',
        align: 'left' as const,
        render: (row: any) => (
          <TooltipWrapper
              text={
                row['lastActive']
                  ? new Date(row['lastActive'] * 1000).toLocaleString()
                  : '-'
              }
          />
        ),
        disableSort: true,
      };
    }

    if (col.title === 'Actions') {
      return {
        key: 'Actions',
        label: '',
        width: '100px',
        align: 'right' as const,
        render: (row: OrganizationUser) => (
          <ContextMenuButton
              row={row}
              onOpenMenu={(e, row) => handleOpenMenu(e, row as OrganizationUser)}
              onCloseMenu={handleCloseMenu}
              anchorEl={anchorEl}
          />
        ),
        disableSort: true,
      };
    }

    return {
      key: col.title,
      label: col.title,
      width: '250px',
      align: 'left' as const,
      render: (row: any) => <TooltipWrapper text={row[col.title]} />,
      disableSort: true,
    };
  });
};
